import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from '../../../models/utilities/document-request';
import { API_METHODS } from '../../../models/utilities/type-models';
import { ApiEndpoints } from '../../../utils/app-constants';

export class DocumentAgingReportExport implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'xlsx';
    public openInTab : boolean = false;
    public url : string = ''; 
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'GET';

    constructor(dealerId: string) {
        this.url = ApiEndpoints.ORDERING_CREDIT_HOLD_AGING_EXPORT.formattify(dealerId);
        this.filename = `${ dealerId }_AgingReport`;
    }

}
